import get from 'lodash/get';
import * as actions from 'actions/DeliveryAddressActions/userAddressActions';
import { LOADING, SUCCESS, ERROR, INIT } from 'utils/asyncStatusHelper';
export default function userAddressReducer(state = {
    asyncStatus: INIT,
    data: null
}, action) {
    switch (action.type) {
        case actions.UserAddressActions.REQUEST:
            return Object.assign({}, state, {
                asyncStatus: LOADING
            });
        case actions.UserAddressActions.SUCCESS:
            const slots = get(action, 'data.slots', []);
            const addressList = slots.filter((slot) => {
                const slotType = get(slot, 'widget.type', '');
                return slotType === 'USER_ADDRESS_SELECTION';
            });
            return Object.assign({}, state, {
                asyncStatus: SUCCESS,
                data: get(addressList, '0.widget.data.renderableComponents', null)
            });
        case actions.UserAddressActions.ERROR:
            return Object.assign({}, state, {
                asyncStatus: ERROR,
                error: action.error
            });
        default:
            return state;
    }
}
